<template>
    <div id="app">
        <header>
            <div class="tw-container tw-flex tw-items-center tw-justify-center tw-py-3 lg:tw-pt-5 lg:tw-pb-6">
                <img src="~@/assets/img/logo.svg">
            </div>
        </header>

        <!-- This will be reaplced by the view defined in the router -->
        <div>
            <router-view/>
        </div>

<!--        <section class="courses tw-container tw-pt-10 tw-pb-12 lg:tw-pt-16 lg:tw-pb-20">-->
<!--            <div class="tw-text-center">-->
<!--                <small class="tw-pt-6 lg:tw-pt-16 tw-pb-5 tw-block tw-mx-auto tw-font-bold tw-uppercase">Cursos e saídas profissionais</small>-->
<!--                <h2>Venha conhecer <br class="lg:tw-hidden">os nossos cursos</h2>-->
<!--                <div class="tw-grid tw-grid-cols-2 tw-gap-10 tw-pt-8 lg:tw-grid-cols-5 lg:tw-pt-16">-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/1.png">-->
<!--                        <p class="tw-pt-3">Agricultura<br> e Espaços Verdes</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/2.png">-->
<!--                        <p class="tw-pt-3">Comunicação<br> Relações Públicas</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/3.png">-->
<!--                        <p class="tw-pt-3">Cuidados<br> Animais</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/4.png">-->
<!--                        <p class="tw-pt-3">Cuidados<br> de Saúde</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/5.png">-->
<!--                        <p class="tw-pt-6">Decoração</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/6.png">-->
<!--                        <p class="tw-pt-3">Informática<br> e Programação</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/7.png">-->
<!--                        <p class="tw-pt-3">Marketing, Design<br> e Multimédia</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/8.png">-->
<!--                        <p class="tw-pt-6">Turismo</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/9.png">-->
<!--                        <p class="tw-pt-3">Serviços <br> Administrativos</p>-->
<!--                    </div>-->
<!--                    <div class="course">-->
<!--                        <img src="~@/assets/img/10.png">-->
<!--                        <p class="tw-pt-6">Videojogos</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="tw-flex tw-items-center tw-justify-center tw-my-8 lg:tw-my-16">-->
<!--              <button-->
<!--                  type="button"-->
<!--                  class="btn-nav"-->
<!--                  @click="scrollTo('header')"-->
<!--              >-->
<!--                Encontre o curso ideal para si-->
<!--              </button>-->
<!--            </div>-->
<!--        </section>-->

        <section class="benefits">
            <div class="tw-container tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                <div class="left-container">
                  <img src="@/assets/img/advantages.png">
                </div>
                <div class="right-container tw-relative">
                    <small class="tw-pt-6 lg:tw-pt-16 tw-pb-5 tw-block tw-font-bold tw-uppercase">Vantagens</small>
                    <h2 class="">Vantagens dos nossos cursos</h2>
                    <div class="">
                        <div class="tw-relative tw-pt-4 lg:tw-pt-8">
                            <p class="title">Bolsas de estágios</p>
                            <p>Aceda ao mercado laboral connosco</p>
                        </div>
                        <div class="tw-relative tw-pt-5 lg:tw-pt-8">
                            <p class="title">Bolsa de Emprego</p>
                            <p>Acesso à nossa Bolsa de Emprego</p>
                        </div>
                        <div class="tw-relative tw-pt-5 lg:tw-pt-8">
                            <p class="title">Campus Virtual</p>
                            <p>Learnnity: a sua comunidade de aprendizagem</p>
                        </div>
                        <div class="tw-relative tw-pt-5 lg:tw-pt-8">
                            <p class="title">Tutor Especializado</p>
                            <p>Técnico especialista na área</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-center tw-my-8 lg:tw-my-16">
              <button
                  type="button"
                  class="btn-nav"
                  @click="scrollTo('header')"
              >
                Encontre o curso ideal para si
              </button>
            </div>
        </section>

        <footer>
            <div class="tw-container">
                <div class="tw-flex tw-items-center tw-justify-between tw-py-4 lg:tw-py-5">
                    <img src="@/assets/img/logo-footer.svg" class="tw-pointer-events-none">
                    <span class="tw-text-white"><a href="#" @click.prevent="$store.state.modal.terms = true">Política de Privacidade</a></span>
                </div>
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <KwPixel/>
    </div>
</template>

<script>
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';

export default {
    components: {
        KwPixel,
        ModalContainer,
        Terms,
    },
    methods: {
        scrollTo(target) {
            document.querySelector(`${target}`).scrollIntoView({
                behavior: 'smooth',
            });
            this.$store.state.coursesList = true;
        },
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
        const data = {
            url: window.location.hostname,
            pubid: this.pubid,
            utm_source: this.$route.query.utm_source,
            utm_campaign: this.$route.query.utm_campaign,
            utm_medium: this.$route.query.utm_medium,
            utm_content: this.$route.query.utm_content,
            utm_term: this.$route.query.utm_term,
            ua_device: this.$store.state.ua_device,
            ua_browser: this.$store.state.ua_browser,
            ua_os: this.$store.state.ua_os,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => console.log(error));
        axios
            .get('https://kw-lp-info.s3-eu-west-1.amazonaws.com/master-d/course-list.json')
            .then((response) => {
                this.$store.state.courseList = response.data;
            });
    },
};
</script>
<style>

</style>
